// MZCNU Landing Page - JS
// Required by: mzcnu-hero.liquid, mzcnu-sticky.liquid

(function () {
  'use strict';

  // ── Hero: Variant Selection ──────────────────────────────────────
  function initHeroVariants() {
    var container = document.querySelector('.mzcn-hero');
    if (!container) return;

    var productJson = container.querySelector('[data-product-json]');
    if (!productJson) return;

    var product;
    try {
      product = JSON.parse(productJson.textContent || productJson.innerText);
    } catch (e) {
      return;
    }

    var buyForm     = container.querySelector('.mzcn-buy-form');
    var priceEl     = container.querySelector('.mzcn-price');
    var compareEl   = container.querySelector('.mzcn-compare-price');
    var variantIdEl = container.querySelector('[name="id"]');

    if (!buyForm || !priceEl) return;

    // Build variant lookup map: key "option1|option2|..." → variant
    var variantMap = {};
    product.variants.forEach(function (v) {
      var key = [
        v.option1 || '',
        v.option2 || '',
        v.option3 || ''
      ].join('|');
      variantMap[key] = v;
    });

    // Update price + compare price + hidden id
    function updatePrice(variant) {
      if (!variant) return;

      if (priceEl) {
        priceEl.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
      }
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.style.display = '';
          compareEl.textContent = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (variantIdEl) {
        variantIdEl.value = variant.id;
      }
    }

    // Sync size buttons with current variant state
    function syncButtons(variant) {
      if (!variant) return;
      var buttons = container.querySelectorAll('.mzcn-size-btn');
      buttons.forEach(function (btn) {
        var opt  = btn.dataset.option;
        var val  = btn.dataset.value;
        var matches = variant[opt] === val;
        btn.classList.toggle('active', matches);
        // Disable sold-out options
        if (!matches) return;
        var isAvailable = variant.available;
        btn.classList.toggle('disabled', !isAvailable);
        btn.disabled = !isAvailable;
      });
    }

    // Size button click handler
    container.querySelectorAll('.mzcn-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var opt = btn.dataset.option;
        var val = btn.dataset.value;

        // Build current selection from active buttons
        var current = {};
        container.querySelectorAll('.mzcn-size-btn.active').forEach(function (activeBtn) {
          current[activeBtn.dataset.option] = activeBtn.dataset.value;
        });
        current[opt] = val;

        var key = [current['Size'] || '', current['Color'] || '', ''].join('|');
        var variant = variantMap[key];

        if (variant) {
          updatePrice(variant);
          syncButtons(variant);
          // Update URL
          if (history.replaceState) {
            var url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url);
          }
        }
      });
    });

    // Init: select first available variant
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvail) {
      updatePrice(firstAvail);
      syncButtons(firstAvail);
      if (variantIdEl) variantIdEl.value = firstAvail.id;
    }

    // Add to cart form submit
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idEl = buyForm.querySelector('[name="id"]');
      if (!idEl || !idEl.value) {
        alert('Please select options first.');
        return;
      }
      var formData = new FormData(buyForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Mini cart or redirect
          window.location.href = '/cart';
        })
        .catch(function () {
          alert('Something went wrong. Please try again.');
        });
    });
  }

  // ── Sticky Bar: Sync with Hero variant ──────────────────────────
  function initStickyBar() {
    var sticky = document.querySelector('.mzcn-sticky');
    if (!sticky) return;

    var heroContainer = document.querySelector('.mzcn-hero');
    var heroIdEl, stickyIdEl;

    function syncSticky() {
      if (!heroIdEl && heroContainer) {
        heroIdEl = heroContainer.querySelector('[name="id"]');
      }
      if (!stickyIdEl) {
        stickyIdEl = sticky.querySelector('[name="id"]');
      }
      if (heroIdEl && stickyIdEl && heroIdEl.value) {
        stickyIdEl.value = heroIdEl.value;
      }
    }

    // Sync on scroll
    window.addEventListener('scroll', syncSticky);

    // Sticky form submit
    var stickyForm = sticky.querySelector('.mzcn-buy-form');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        syncSticky();
        var formData = new FormData(stickyForm);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            alert('Something went wrong. Please try again.');
          });
      });
    }
  }

  // ── FAQ Accordion ───────────────────────────────────────────────
  function initFAQ() {
    document.querySelectorAll('.mzcn-faq-item').forEach(function (item) {
      var q = item.querySelector('.mzcn-faq-question');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Close all
        item.closest('.mzcn-faq-list')
          .querySelectorAll('.mzcn-faq-item')
          .forEach(function (el) { el.classList.remove('open'); });
        // Toggle current
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  // ── Fade-up on scroll ───────────────────────────────────────────
  function initFadeUp() {
    var els = document.querySelectorAll('.mzcn-fade-up');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ── Init ────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeroVariants();
      initStickyBar();
      initFAQ();
      initFadeUp();
    });
  } else {
    initHeroVariants();
    initStickyBar();
    initFAQ();
    initFadeUp();
  }
})();
